class MyFavorites {
    constructor() {
        this.storageKey = "myFavorites";
        this.localStorageFavorites = localStorage.getItem(this.storageKey);
        this.favorites = {
            favorites: [],
        };
        this.myFavorites = this.localStorageFavorites
            ? JSON.parse(this.localStorageFavorites)
            : this.favorites;

        this.mastheadSavedIcon = document.querySelector('.masthead__saved-icon');
    }

    isInFavorites(id) {
        const filterById = this.myFavorites.favorites.filter((favorite) => favorite.post_id === id);
        return filterById.length > 0 ? true : false;
    }
    setButtonState(post_id, isTrue) {
        const favoriteButtons = document.querySelectorAll(`button[data-post-id="${post_id}"]`);

        favoriteButtons.forEach((button) => {
            button.dataset.isFavorited = isTrue
        });
    }

    setSavedMenuState() {

        if( this.myFavorites.favorites.length === 0) {
            this.mastheadSavedIcon?.classList.remove('has-saved');
        } else {
            this.mastheadSavedIcon?.classList.add('has-saved');
        }
    }


    removeFavoriteById(id) {
        // Ensure jsonData has a 'favorites' array
        if (!this.myFavorites || !this.myFavorites.favorites || !Array.isArray(this.myFavorites.favorites)) {
            throw new Error("Invalid JSON data");
        }

        // Find the index of the object with the matching post_id
        const index = this.myFavorites.favorites.findIndex(item => item.post_id === id);

        // If an object with the given post_id is found, remove it
        if (index !== -1) {
            this.myFavorites.favorites.splice(index, 1);
            localStorage.setItem(this.storageKey, JSON.stringify(this.myFavorites));
            this.setButtonState(id, false);
            this.setSavedMenuState();
        } else {
            console.log(`No favorite found with post_id: ${id}`);
        }
    }

    addToMyFavorites(favoriteItem) {
        this.myFavorites.favorites.push(favoriteItem);
        localStorage.setItem(this.storageKey, JSON.stringify(this.myFavorites));
        this.setButtonState(favoriteItem.post_id, true);
        this.setSavedMenuState();
    }

    setFavorite(button) {
		const postId = button.dataset.postId;
        if (this.isInFavorites(postId)) return;

		const container = button.closest('.card__wrap');
		const classes = container ? {
				wrap: '.card__wrap',
				title: '.card__heading',
				date:  '.card__date',
				url: '.card__link'
			} : {
				wrap: '.excerpt__content',
				title: '.excerpt__title',
				date:  '.excerpt__date',
				url: '.excerpt__link'
			};

        const favoriteItem = {
            post_id: postId,
            title: container.querySelector(classes.title)?.innerText,
            url: container.querySelector(classes.url)?.getAttribute('href'),
            date: container.querySelector('.card_date')?.innerText,
            image: container.querySelector("img")?.getAttribute('src'),
            post_type: button.dataset.postType
        }
        this.addToMyFavorites(favoriteItem);
    }

    setFavoriteFromData(button) {
        const postId = button.dataset.postId;
        if (this.isInFavorites(postId)) return;

        const favoriteItem = {
            title: button.dataset.postTitle,
            url: button.dataset.postUrl,
            image: button.dataset.postImage,
            date: button.dataset.postDate,
            post_id: postId,
            post_type:  button.dataset.postType
        }
        this.addToMyFavorites(favoriteItem);
    }

    isFavorited(button) {
        if (button.dataset.isFavorited === 'true') return true;
        return false;
    }

    favoriteButtonAction(e) {
        if (this.isFavorited(e.target)) {
            this.removeFavoriteById(e.target.dataset.postId);
        } else {
            this.setFavorite(e.target)
        }
    }

    favoriteButtonFromDataAction(e) {
        if (this.isFavorited(e.target)) {
            this.removeFavoriteById(e.target.dataset.postId);
        } else {
            this.setFavoriteFromData(e.target)
        }
    }


    initialize() {
        this.setSavedMenuState();

        document.body.addEventListener('click', (e)=> {
            const node = e.target;
            if( node.classList.contains('favorite-toggle')) {
                this.favoriteButtonAction(e);
            }
            if( node.classList.contains('favorite-data-toggle')) {
                this.favoriteButtonFromDataAction(e);
            }
        });

        // Loop through ids in local storage and set the correct button state
        this.myFavorites.favorites.forEach(favorite => {
            this.setButtonState(favorite.post_id, true);
        });


    }
}

const wdgFavorites = new MyFavorites();
wdgFavorites.initialize();
